import { useSidebar } from '@/context/SidebarContext'
import { Box } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { Loading } from '../../../../components/Loading'
import { Note } from '../../../../components/Note'
import { Steps } from '../../../../components/Steps'
import { WizzardHeader } from '../../../../components/WizzardHeader'
import { useInsuranceParams } from '../../../../context/InsuranceParamsProvider'
import { useMeetingRecord } from '../../../../context/MeetingRecordProvider'
import { PageWrapper } from '../../../../layouts/components/PageWrapper'
import { Sidebar } from '../../../../layouts/components/Sidebar'
import { Step4 } from './Step4'

export const Step4Wrapper = () => {
  const navigate = useNavigate()
  const [noteText, setNoteText] = useState<string | undefined>(undefined)
  const handleCreateNote = () => {
    setNoteText('Nová poznámka')
  }

  const { insuranceParams, insuranceParamsId: paramsId, isDisabled } = useInsuranceParams()
  const { refetch, meetingRecord, isLoading } = useMeetingRecord()
  const { setPageSections } = useSidebar()

  useEffect(() => {
    if (!insuranceParams!.generalParams.selectedOfferId) {
      navigate(`/travel/steps/2/${paramsId}`)
      return
    } else {
      refetch()
    }
  }, [])

  // stavalo se, ze po sjednani pri prvnim renderu zustavaly registrovane sekce s formulari (mimo form context)
  useEffect(() => {
    setPageSections([])
  }, [isDisabled])

  return (
    <PageWrapper
      header={<WizzardHeader onCreateNote={handleCreateNote} />}
      steps={<Steps />}
      sidebar={<Sidebar />}
      contentProps={{
        sx: {
          pt: { base: 0, md: 0 },
        },
      }}
    >
      {noteText && noteText !== '' && (
        <Note
          date="11.10.2021 14:35"
          text={noteText}
          onChange={(text) => setNoteText(text)}
        />
      )}

      <Box sx={{ pt: { base: 0, md: !noteText ? 8 : 0 } }}>
        {isLoading && <Loading large={true} />}

        {!isLoading && meetingRecord && !isDisabled &&
                    <Step4 />
        }
      </Box>
    </PageWrapper>
  )
}
